import { createResource } from "@evergis/react-fetching";
import { StatisticsDbParams, GetStatisticsDc } from "@evergis/api";

import { api as evergisApi } from "../evergis/api";

export const getStatistic = createResource(
  (params: StatisticsDbParams) => async api => ({
    data: await api.statistic.getStatistic(params),
  }),
  { injected: evergisApi, cacheSize: 1000 },
);

export const getStatisticPost = createResource(
  (params: GetStatisticsDc) => async api => ({
    data: await api.statistic.postStatistic(params),
  }),
  {
    injected: evergisApi,
  },
);
